import { useContext } from 'react';
import { useTypedSelector } from 'store/common/TypedSelector';

import { AuthContext } from 'services/core/context/AuthContext';

import { AsyncReducerStatus } from 'store/common/AsyncReducerStatus';
import { permissionGroupCyclotronProduct } from 'services/core/lib/auth/AuthService';
import { Guid } from 'lib/guid/Guid';

import { MainLayoutSection } from 'presentation/ui/layouts/main-layout/main-layout-section/MainLayoutSection';
import { MainLayoutSectionSection } from 'presentation/ui/layouts/main-layout/main-layout-section/MainLayoutSectionSection';
import { ViewLayout } from 'presentation/ui/layouts/view-layout/ViewLayout';
import { ViewLayoutSection } from 'presentation/ui/layouts/view-layout/view-layout-section/ViewLayoutSection';
import { NotificationBars } from 'presentation/ui/components/notification-bars/NotificationBars';
import { NotificationBar } from 'presentation/ui/components/notification-bar/NotificationBar';
import { NotificationLevel } from 'presentation/ui/components/notification-bar/NotificationLevel';
import { CyclotronProductCollection } from '../ui/card-collections/cyclotron-product-collection/CyclotronProductCollection';

/**
 * The cyclotrons view
 */
export const CyclotronProductsView = (): JSX.Element => {

	// Consume the contexts
	const authContext = useContext(AuthContext);

	// Use a custom selector function to provide type information for the state definde in the slice
	const storeActionStatus = useTypedSelector(state => state.cyclotronProducts.actionStatus);
	const storeLastActionError = useTypedSelector(state => state.cyclotronProducts.lastActionError);

	// Handle permissions
	if (!authContext.hasAnyPermission(permissionGroupCyclotronProduct)) {
		throw new Error('Permission denied');
	}

	const renderNotifications = (): Array<JSX.Element> => {
		const notifications = [];
		if (storeActionStatus === AsyncReducerStatus.FAILED) {
			notifications.push(
				<NotificationBar
					key={Guid.generate()}
					message={storeLastActionError.message}
					level={NotificationLevel.LEVEL_ERROR}
				/>
			);
		}
		return notifications;
	};

	return (
		<MainLayoutSection section={MainLayoutSectionSection.SECTION_MAIN}>
			<ViewLayout>
				<ViewLayoutSection>
					<NotificationBars>
						{renderNotifications()}
					</NotificationBars>
				</ViewLayoutSection>

				<ViewLayoutSection>
					<CyclotronProductCollection />
				</ViewLayoutSection>
			</ViewLayout>
		</MainLayoutSection>
	);
};
